// Module
var code = `<!-- table html -->
<!-- table.html -->
<div class="slick-container alpine-theme">
  <div id="table-target"></div>
</div>

`;
// Exports
export default code;